import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Load Meta Pixel
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '1460327352496166');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-gold/30 selection:text-navy-900" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <FAQSection data-id="element-8" />
        <CTASection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}